import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=c7677688&scoped=true"
import script from "./ProductHeader.vue?vue&type=script&lang=ts"
export * from "./ProductHeader.vue?vue&type=script&lang=ts"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&id=c7677688&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7677688",
  null
  
)

export default component.exports